// Copyright 2024 Sorama B.V.
import { Range } from "datatypes/SoramaWebApi";

// Re-export from shared location to avoid circular dependencies
export { HarmonicSelectionMode, HarmonicSelectionModes } from "services/FrequencySelection/HarmonicSelectionModes";

export class NarrowbandSelectionModes {
    public static maxBand = "Maximum";
    public static centerBand = "Center";
    public static none = "None";

    public static all: string[] = [
        NarrowbandSelectionModes.maxBand,
        NarrowbandSelectionModes.centerBand,
        NarrowbandSelectionModes.none,
    ];
}
export type NarrowbandSelectionMode = (typeof NarrowbandSelectionModes.all)[number];

export class ComputationModes {
    public static normal: ComputationMode = "High-Res";
    public static iV64: ComputationMode = "IV64";

    /**
     * Based on the mode, return a range of valid frequencies to show
     * @param mode the computation mode that is used
     * @returns a range of valid frequencies for the given mode
     */
    public static getValidFrequencyRange(mode: ComputationMode): Range {
        switch (mode) {
            case ComputationModes.normal:
                return <Range>{ from: 22, to: Infinity };
            case ComputationModes.iV64:
                return <Range>{ from: 29, to: 22387 };
            default:
                return <Range>{ from: 0, to: Infinity };
        }
    }

    public static all: ComputationMode[] = [ComputationModes.normal, ComputationModes.iV64];
}

export type ComputationMode = "High-Res" | "IV64";
